import { useDispatch } from 'react-redux'
import { updateQuery as updateQueryAction, resetOwnersList, dismissExtendedModal } from '../../stores/ticketsScanner/actions'

const TicketsScannerOwnersListItem = ({ barcode, name, email }) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(updateQueryAction(barcode))
    dispatch(resetOwnersList())
    dispatch(dismissExtendedModal())
  }

  return (
    <tr
      style={{ cursor: "pointer" }}
      key={barcode}
      onClick={handleClick}
    >
      <td dangerouslySetInnerHTML={{ __html: name }}></td>
      <td>{email}</td>
      <td>{barcode}</td>
    </tr>
  )
}

export default TicketsScannerOwnersListItem
